import { jsx as _jsx } from "react/jsx-runtime";
import { AllPluginsRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/all-plugins-rule/all-plugins-rule';
import { InternalRepoPluginRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/internal-repo-plugin-rule/internal-repo-plugin-rule';
import { VendorPluginsRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/vendor-plugins-rule/vendor-plugins-rule';
import { SinglePluginRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/single-plugin-rule/single-plugin-rule';
export function PluginRule({ rule, ...rest }) {
    switch (rule.type) {
        case 'all-plugins':
            return _jsx(AllPluginsRule, { rule: rule, ...rest });
        case 'internal-repo':
            return _jsx(InternalRepoPluginRule, { rule: rule, ...rest });
        case 'vendor-plugins':
            return _jsx(VendorPluginsRule, { rule: rule, ...rest });
        case 'single-plugin':
            return _jsx(SinglePluginRule, { rule: rule, ...rest });
        default:
            return assert_exhaustive(rule);
    }
}
